export default "__VITE_ASSET__BPo$rqnu__"